import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './Clientes.css';
import './Home';
import img1 from '../assets/images/IMMSA-cli.jpg';
import img2 from '../assets/images/CUETARA-cli.jpg';
import img3 from '../assets/images/LA-PALOMA-cli.jpg';
import img4 from '../assets/images/ALUBIN-cli.jpg';
import img5 from '../assets/images/NICRO-cli.jpg';
import img6 from '../assets/images/FARMACOS-DAROVI-cli.jpg';
import Facebok from '../assets/images/Facebok.png';
import Wasa from '../assets/images/Wasa.png';
import insta from '../assets/images/insta.png';
import Ubi from '../assets/images/Ubi.png';
import Telefono from '../assets/images/Telefono.png';
import Email34 from '../assets/images/Correo.png';
import RedesFondo from '../assets/images/Red-Neuronal.png';
import checkAnim from '../assets/images/check.gif';
import ImagenBannerCLI from '../assets/images/BannerCLI.jpg';


const casos = [
  //Imagen Caso Éxito IMMSA de inicio Casos de Éxito
  { title: 'IMMSA', desc: 'METALMECANICA', img: img1, ruta: 'IMMSA'},
  //Imagen Caso Éxito CUETARA de inicio Casos de Éxito
  { title: 'Cuetara', desc: 'ALIMENTARIA', img: img2, ruta: 'CUETARA'   },
  //Imagen Caso Éxito CUETARA de inicio Casos de Éxito 
  { title: 'La Paloma', desc: 'COMERCIALIZADORA DE METALES Y PLÁSTICOS INDUSTRIALES', img: img3, ruta: 'LAPALOMA'   },
  //Imagen Caso Éxito ALUBIN de inicio Casos de Éxito
  { title: 'Alubin', desc: 'ALUMINIO', img: img4, ruta: 'Alubin'   },
  //Imagen Caso Éxito NICRO de inicio Casos de Éxito
  { title: 'Nicro', desc: 'AUTOMOTRIZ', img: img5, ruta: 'NICRO'   },
  //Imagen Caso Éxito FARMACOS DAROVI de inicio Casos de Éxito 
  { title: 'Farmacos Darovi', desc: 'FARMACÉUTICA', img: img6, ruta: 'FARMACOS'  },
];


const CasosExito = () => {

  const [enviado, setEnviado] = useState(false);
  
    const handleSubmit = (e) => {
      e.preventDefault();
      const form = e.target;
  
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
      }).then(() => {
        setEnviado(true);
        form.reset();
        // Opcional: volver a mostrar formulario después de 5s
        // setTimeout(() => setEnviado(false), 5000);
      });
    };
  return (
    <>
    {/*Imagen Inicio Casos Éxito*/}
<div className="infra-banner-cli">
  {/* Imagen en la sección de inicio Casos de Éxito */}
  <img src={ImagenBannerCLI} alt="Clientes" className="banner-img-cli" />
  {/*Titulo Casos de Éxito Sección Inicio  */}
    <h1 className="banner-texto-cli">Casos de Exito</h1>
</div>

{/*Bloque introducción Casos de Éxito */}
<div className="infra-descripcion-cli">
  {/*Texto Sección Sobre Nosotros */}
  <p>
    En GRUPO IATEKZA transformamos la tecnologia en resultados reales. Hemos ayudado a empresas a mejorar sus procesos, optimizar recursos 
    y crecer mediante soluciones como sistemas de gestion, desarrollo de software
    a la medida y equipos tecnológicos. Cada proyecto exitoso refleja nuestro
    compromiso con la innovacion, la eficiencia y el crecimiento de nuestros
    clientes.
  </p>
</div>

      {/*Bloque Menú Casos de Éxito */}
      <div className="exito-galeria-container">
        <div className="exito-galeria">
          {casos.map((item, i) => (
            <Link to={`/caso/${item.ruta}`} key={i} className="exito-item">
              <img src={item.img} alt={item.title} />
              <div className="exito-overlay">
                <div className="exito-overlay-contenido">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

   {/* Contenedor principal del formulario de contacto*/}
 <div className="formulario-imagen-style20">
  <div className="linea-superior20"></div>

  {/* Cambia el título según el estado */}
  <h2>
     {/*Titulo Formulario*/}
  {!enviado ? (
    'Contáctanos para más información'
  ) : (
    <>
    {/* Titulo al enviar*/}
      GRACIAS POR CONTACTARNOS !!!<br />
        Un especialista se pondrá en contacto contigo.
    </>
  )}
</h2>

  {!enviado ? (
    <form
      onSubmit={handleSubmit}
      action="https://formsubmit.co/ivan.benitez@iatekza.com"
      method="POST"
      className="formulario-simple20"
    >
      {/* Campos de entrada para nombre, teléfono, correo, empresa y mensaje */}
      <input type="hidden" name="_captcha" value="false" />
{/* Campo nombre*/}
      <input type="text" name="nombre" placeholder="Nombre" required />
      {/* Campo Número Telefónico */}
      <input type="tel" name="numero" placeholder="Número Telefónico" required />
      {/* Campo Correo Electronico*/}
      <input type="email" name="correo" placeholder="Correo Electrónico" required />
      {/* Campo Empresa*/}
      <input type="text" name="empresa" placeholder="Empresa (Opcional)" />
      <textarea name="mensaje" placeholder="Mensaje" required></textarea>
{/* Botón de envío del formulario*/}
      <button type="submit">Enviar</button>
    </form>
  ) : (
    <div className="confirmacion-envio20">
      {/* gift al enviar formulario */}
      <img src={checkAnim} alt="Éxito20" />
{/* Texto abajo al enviar*/}
      <p>¡ Mensaje enviado correctamente !</p>
    </div>
  )}
</div>


{/* Contenedor principal  de pie de página con contacto*/}

<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>
{/* Ubicación contacto*/}
  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>
{/* Numero contacto*/}
  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>
{/* Correo contacto*/}
  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        {/* IAutomatiza CFDI Colum 3*/}
        <li><a href="/">• IAutomatiza CFDI</a></li>
        {/*Facturacion Electronica Colum 3*/}
        <li><a href="/Facturacion">• Facturacion Electronica</a></li>
        {/* Servicio Infraestructura TI colum 2*/}
        <li><a href="/Comercializacion">• Infraestructura TI</a></li>
        {/* Servicio Asesoría empresarial colum 2*/}
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
       {/* Servicio Soluciones Tecnológicas colum 2*/}
        <li><a href="/Sistemas">• Soluciones Tecnologícas</a></li>
      </ul>
      {/*Facebook Colum 2*/}
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        {/*Wasak Colum 2*/}
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        {/*Insta Colum 2*/}
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
        {/*Sobre Nosotros Colum 3*/}
        <li><a href="/Nosotros">Sobre nosotros</a></li>
        {/*Aviso Legal Colum 3*/}
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>
{/*Línea de derechos reservados */}
  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>
    
    </>
  );
};

export default CasosExito;

